// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  reports101: [],
  reports102: [],
  reports103: [],
  reports104: [],
  reports105: [],
  reports106: [],
  reports107: [],
  totalReports101: 0,
  totalReports102: 0,
  totalReports103: 0,
  totalReports104: 0,
  totalReports105: 0,
  totalReports106: 0,
  totalReports107: 0,
}

export const mutations = {
  SET_TOTAL_REPORTS_101(state, totalReports101) {
    state.totalReports101 = totalReports101
  },
  SET_TOTAL_REPORTS_102(state, totalReports102) {
    state.totalReports102 = totalReports102
  },
  SET_TOTAL_REPORTS_103(state, totalReports103) {
    state.totalReports103 = totalReports103
  },
  SET_TOTAL_REPORTS_104(state, totalReports104) {
    state.totalReports104 = totalReports104
  },
  SET_TOTAL_REPORTS_105(state, totalReports105) {
    state.totalReports105 = totalReports105
  },
  SET_TOTAL_REPORTS_106(state, totalReports106) {
    state.totalReports106 = totalReports106
  },
  SET_TOTAL_REPORTS_107(state, totalReports107) {
    state.totalReports107 = totalReports107
  },
  SET_REPORTS_101(state, reports101) {
    state.reports101 = reports101
  },
  SET_REPORTS_102(state, reports102) {
    state.reports102 = reports102
  },
  SET_REPORTS_103(state, reports103) {
    state.reports103 = reports103
  },
  SET_REPORTS_104(state, reports104) {
    state.reports104 = reports104
  },
  SET_REPORTS_105(state, reports105) {
    state.reports105 = reports105
  },
  SET_REPORTS_106(state, reports106) {
    state.reports106 = reports106
  },
  SET_REPORTS_107(state, reports107) {
    state.reports107 = reports107
  },
}

export const actions = {
  fetchReports101({ commit }, payload) {
    return ApiService.fetchReports101(payload)
      .then((res) => {
        const result = res.data
        commit('SET_TOTAL_REPORTS_101', result.total)
        commit('SET_REPORTS_101', result.data)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports102({ commit }, payload) {
    return ApiService.fetchReports102(payload)
      .then((res) => {
        const result = res.data
        commit('SET_TOTAL_REPORTS_102', result.total)
        commit('SET_REPORTS_102', result.data)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports103({ commit }, payload) {
    return ApiService.fetchReports103(payload)
      .then((res) => {
        const result = res.data
        commit('SET_TOTAL_REPORTS_103', result.total)
        commit('SET_REPORTS_103', result.data)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports104({ commit }, payload) {
    return ApiService.fetchReports104(payload)
      .then((res) => {
        const result = res.data
        commit('SET_TOTAL_REPORTS_104', result.total)
        commit('SET_REPORTS_104', result.data)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports105({ commit }, payload) {
    return ApiService.fetchReports105(payload)
      .then((res) => {
        const result = res.data
        commit('SET_TOTAL_REPORTS_105', result.total)
        commit('SET_REPORTS_105', result.data)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports106({ commit }, payload) {
    return ApiService.fetchReports106(payload)
      .then((res) => {
        const result = res.data
        commit('SET_TOTAL_REPORTS_106', result.total)
        commit('SET_REPORTS_106', result.data)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports107({ commit }, payload) {
    return ApiService.fetchReports107(payload)
      .then((res) => {
        const result = res.data
        commit('SET_TOTAL_REPORTS_107', result.total)
        commit('SET_REPORTS_107', result.data)
      })
      .catch((error) => {
        throw error
      })
  },
}
